import React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';

function DataLoading(Component) {
	return function DataLoadingComponent({ isLoading, dataType, ...props }) {
		if (!isLoading) return <Component {...props} />;
		return (
			<Box
				sx={{
					bgcolor: '#FFFFFF',
					border: 1,
					borderColor: '#CCCCCC',
					borderRadius: 1,
					height: '100%'
				}}
			>
				<Grid container>
					<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width='100%' height={50}/>
					<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width='100%' height={50}/>
					<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width='100%' height={50}/>
					<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width='100%' height={50}/>
					<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width='100%' height={50}/>
					<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width='100%' height={50}/>
					<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width='100%' height={50}/>
					<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width='100%' height={50}/>
					<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width='100%' height={50}/>
					<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width='100%' height={50}/>
				</Grid>
			</Box>
		);
	};
}

// function DataLoading(Component) {
// 	return function DataLoadingComponent({ isLoading, dataType, ...props }) {
// 		if (!isLoading) return <Component {...props} />;
// 		return (
// 			<p style={{ fontSize: '25px' }}>
// 				Loading {dataType}. Please wait...
// 			</p>
// 		);
// 	};
// }

export default DataLoading;